module.exports = __webpack_public_path__ + "img/ic_fluent_arrow_undo_24_regular.1aabefd6.svg";